import { FC } from 'react'
import { ScheduleType } from './types'
import { convertToSchedule } from './convertToSchedule'
import { ScheduleP, ScheduleRow } from './styles'
import { useTranslations } from '../../featureSliced/shared/hooks/useTranslations'
import { RenderIf } from '../RenderIf'

export const Schedule: FC<ISchedule> = ({ schedule }) => {
  const t = useTranslations()
  const [sch, closed] = convertToSchedule(schedule)

  const renderDays = (value: string) =>
    value
      .split('-')
      .map((code: any) => t(`clickCollect.${[code]}`))
      .join('-')

  return (
    <>
      <RenderIf condition={sch.length > 0}>
        {sch.map((el: [string, string], i: number) => (
          <ScheduleRow key={`scedule_item_${i}`}>
            <ScheduleP>{renderDays(el[0])}</ScheduleP>
            <p>{el[1]}</p>
          </ScheduleRow>
        ))}
      </RenderIf>
      <RenderIf condition={closed.length > 0}>
        <ScheduleRow key={`scedule_item_${-1}`}>
          <ScheduleP>
            {closed.map((code) => renderDays(code)).join(', ')}
          </ScheduleP>
          <p>{t('clickCollect.closed')}</p>
        </ScheduleRow>
      </RenderIf>
    </>
  )
}

interface ISchedule {
  schedule: ScheduleType
}
